import { retweetsConfig } from '../retweets';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerRetweetsSimpleConfig = {
    ...retweetsConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
